<template>
  <div class="p-4">
    <l-container class="mb-4">
      <l-container-title
        slot="toolbar"
        :text= "this.$t('sensors')"
        icon="network-wired"
        color="bg-pastel-purple"
      />
      {{$t('plotdescription1')}}
      {{$t('plotdescription2')}}
    </l-container>
    
    <input class="block mb-2 text-sm font-medium text-gray-900 dark:text-white" id="search_field" type="search" placeholder="Search">
    
    <l-button type="success" @click="onPlot">{{$t('plotdata')}}</l-button><br/>
    <hot-table :data="sensors" :settings="settings" ref="hot" :key="componentKey">
      <hot-column :title="this.$t('provider')" data="provider.name" read-only="true"></hot-column>
      <hot-column title="ID" data="id" read-only="true"></hot-column>
      <hot-column :title="this.$t('name')" data="name" read-only="true"></hot-column>
      <hot-column :title="this.$t('description')" data="description" read-only="true"></hot-column>
<!--       <hot-column :title="this.$t('sensorregistered')" :renderer="dateRenderer" data="created" read-only="true"></hot-column> -->
      <hot-column :title="this.$t('lastprocessed')" :renderer="dateRenderer"  data="pipeline.processed" read-only="true"></hot-column>
      <hot-column :title="this.$t('status')" data="pipeline.status" read-only="true"></hot-column>
      <hot-column :title="this.$t('enabled')" data="enabled" read-only="true"></hot-column>
    </hot-table>
  </div>
</template>

<script>
import ContextMenu from "./context.menu";
import HandsontableHelper from "@/helpers/settings/handsontable";
import "handsontable/dist/handsontable.full.css";
import { HotTable, HotColumn } from "@handsontable/vue";
import Handsontable from "handsontable";
import SensorsService from "@/helpers/apiservices/sensors/sensors.service";
import ObservationsService from "@/helpers/apiservices/observations/observations.service";
import { LButton } from "@/components/forms";
import Notify from "@/helpers/notify";
import router from "../../../router";
import * as moment from "moment";

const ID_COLUMN = 1;
var hottable;

export default {
  name: "sensors",
  components: {
    HotTable,
    HotColumn,
    LButton 
  },
  data() {
    return {
      sensors: [],
      settings: HandsontableHelper.settings(false),
      dateRenderer: HandsontableHelper.dateRenderer,
      epochRenderer: HandsontableHelper.epochRenderer,
      componentKey: 0,
      refs: this.$refs
    };
  },
  mounted() {
    hottable = this.$refs.hot.hotInstance;
    this.settings.afterSelectionEnd = this.selectRowOnly;
    this.settings.dropdownMenu = false;
    this.settings.contextMenu = ContextMenu(this);
    this.settings.outsideClickDeselects = false;
    this.settings.columnSorting.initialConfig.column = 4;

    //Testing without using Notify
    //Notify.loadData(null, this.loadInitialData);
    this.loadInitialData();

    this.adjustTable();
    //forcing recreation of hot-table since nor re-rendering of table or edit settings updated headers
    this.$root.$on('rendertable', () => {
      this.componentKey += 1;
    }); 

      //search fields listenere
      const searchField = document.querySelector('#search_field');
    searchField.addEventListener('keyup', function(event) {
      const search = hottable.getPlugin('search');
      const queryResult = search.query(event.target.value);
      hottable.render();
    });

  },
  methods: {
    async loadInitialData() {
      this.sensors = await SensorsService.sensors();
    },

    adjustTable(){
      this.$refs.hot.hotInstance.view.wt.update('onCellDblClick', this.onDoubleClick);

      hottable.updateSettings({
        cells: function(row, col) {
          var cellProperties = {};
          var date = moment(hottable.getDataAtCell(hottable.toVisualRow(row), 4));
          if(date.isBefore(moment(), 'day')){
            cellProperties.className = 'oldData';
          }
          return cellProperties;
        },
      });

    },

    onDoubleClick(event, h){
      var plotsensors = [];
      plotsensors.push(this.getSensor(this.$refs.hot.hotInstance.getDataAtRow([h.row])[ID_COLUMN]));
      router.push({
          name: 'ObservationsPlot',
          params: {
              sensors: plotsensors
          }
      });
    },

    onPlot() {
      var selected = this.$refs.hot.hotInstance.getSelected();
      var plotsensors = [];
      //row range, [0] = row start, [2] row end
      selected.forEach(sel => {
        for(var i= sel[0]; i <= sel[2]; i++){
          try{
            plotsensors.push(this.getSensor(this.$refs.hot.hotInstance.getDataAtRow([i])[ID_COLUMN]));
          }
          catch(e){}  
        }
      });

      router.push({
          name: 'ObservationsPlot',
          params: {
              sensors: plotsensors
          }
      });
    },
    getSensor(id){
      return this.sensors.find(s => s.id == id);
    }

  }
};
</script>

<style >
/* .handsontable .highlight {
  color: red !important;
} */
.handsontable .oldData
{
  background-color: lightgrey;
  font-weight: bold;
}
</style>


